// pull-refresh.js — 移动端下拉刷新（整页重载）
// 对标手机浏览器原生下拉刷新：主内容区已在顶部时，向下滑动超过阈值即整页重载。
// 仅在移动壳启用；聊天/个人信息等浮层、底部导航上的触摸不触发，避免误刷新丢失状态。

var THRESHOLD = 60; // 触发刷新的下拉距离（px）
var MAX_PULL = 90;  // 指示条最大跟随位移（px）

var _indicator = null;
var _startY = 0;
var _startX = 0;
var _active = false;   // 本次触摸是否从主内容区（#pageSlot）开始
var _pulling = false;  // 是否已进入「顶部下拉」状态
var _dist = 0;         // 当前下拉距离

function mainEl() {
  return document.getElementById('pageSlot');
}

function ensureIndicator() {
  if (_indicator) return _indicator;
  var el = document.createElement('div');
  el.setAttribute('aria-hidden', 'true');
  el.textContent = '↓ 下拉刷新';
  el.style.cssText = [
    'position:fixed', 'top:0', 'left:0', 'right:0', 'height:44px',
    'display:flex', 'align-items:center', 'justify-content:center',
    'font-size:13px', 'color:#8a8a8e', 'background:transparent',
    'pointer-events:none', 'z-index:999',
    'transform:translateY(-100%)'
  ].join(';');
  document.body.appendChild(el);
  _indicator = el;
  return el;
}

function setIndicator(dist) {
  var el = ensureIndicator();
  var shown = Math.min(dist, MAX_PULL);
  el.style.transition = 'none';
  el.style.transform = 'translateY(' + (-44 + shown) + 'px)';
  el.textContent = dist >= THRESHOLD ? '松开刷新' : '↓ 下拉刷新';
}

function hideIndicator() {
  if (!_indicator) return;
  _indicator.style.transition = 'transform .2s ease';
  _indicator.style.transform = 'translateY(-100%)';
}

// 有打开的浮层（聊天/个人信息等）时不下拉
function hasOpenOverlay() {
  return !!document.querySelector('.panel.open');
}

// 是否可下拉：主容器已在顶部且无浮层
function canPull() {
  if (hasOpenOverlay()) return false;
  var main = mainEl();
  return !!(main && main.scrollTop <= 0);
}

function reset() {
  _pulling = false;
  _dist = 0;
  hideIndicator();
}

export function initPullRefresh() {
  // 仅移动壳启用（桌面壳无 mobile-tpl）；无触摸能力的环境不启用
  if (!document.getElementById('mobile-tpl')) return;
  if (!('ontouchstart' in window)) return;

  document.addEventListener('touchstart', function(e) {
    if (e.touches.length !== 1) { reset(); return; }
    _startY = e.touches[0].clientY;
    _startX = e.touches[0].clientX;
    var main = mainEl();
    _active = !!(main && main.contains(e.target));
    _pulling = false;
    _dist = 0;
  }, { passive: true });

  document.addEventListener('touchmove', function(e) {
    if (!_active || e.touches.length !== 1) return;
    var y = e.touches[0].clientY;
    var x = e.touches[0].clientX;
    var dy = y - _startY;
    var dx = x - _startX;

    if (!_pulling) {
      // 仅「主容器在顶部 + 明显下拉 + 纵向为主」才进入下拉
      if (dy <= 0) return;
      if (Math.abs(dx) > Math.abs(dy)) return;
      if (!canPull()) return;
      _pulling = true;
    }

    // 已进入下拉后：往上推或转为横向 → 放弃
    if (dy <= 0 || Math.abs(dx) > Math.abs(dy) * 1.2) {
      reset();
      return;
    }

    // 阻止系统原生下拉刷新 / 橡皮筋
    if (e.cancelable) e.preventDefault();
    _dist = dy;
    setIndicator(dy);
  }, { passive: false });

  document.addEventListener('touchend', function(e) {
    if (_pulling && _dist >= THRESHOLD) {
      location.reload();
      return;
    }
    reset();
  }, { passive: true });

  document.addEventListener('touchcancel', function() {
    reset();
  }, { passive: true });
}
